import React from "react";
import styles from "./Introduction.module.css";
import heroImage from "./hero-textile.jpg";

const Introduction = () => {
  return (
    <section
      className={styles.introduction}
      style={{ backgroundImage: `url(${heroImage})` }}
    >
      {/* Overlay */}
      <div className={styles.overlay}></div>

      {/* Conteúdo */}
      <div className={styles.content}>
        <h1 className={styles.title}>
          O Futuro da <span>Gestão Têxtil</span>
        </h1>
        <p className={styles.subtitle}>
          Sistema completo para facções de costura com mais de 25 anos de
          experiência no chão de fábrica. Transforme sua gestão com tecnologia e
          conhecimento especializado.
        </p>

        {/* Botão e Input */}
        <div className={styles.actions}>
          <button
            className={styles.button}
            onClick={() => {
              window.open(
                "https://wa.me/5547988136845?text=Ol%C3%A1%20Lucimar,%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20sistema%20Redech.",
                "_blank"
              );
            }}
          >
            Conversar agora pelo WhatsApp
          </button>
        </div>


        {/* Métricas */}
        <div className={styles.metrics}>
          <div>
            <p className={styles.metricValue}>25+</p>
            <span className={styles.metricLabel}>Anos de Experiência</span>
          </div>
          <div>
            <p className={styles.metricValue}>100+</p>
            <span className={styles.metricLabel}>Clientes Atendidos</span>
          </div>
          <div>
            <p className={styles.metricValue}>99%</p>
            <span className={styles.metricLabel}>Satisfação</span>
          </div>
        </div>
      </div>

      {/* Mouse pulando */}
      <div className={styles.mouseWrapper}>
        <div className={styles.mouseShape}>
          <div className={styles.mouseWheel}></div>
        </div>
      </div>
    </section>
  );
};

export default Introduction;
